import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useListAccountingTypes } from '@/entities/masters/api/generated/api';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { ExpenditureItemsForm } from './ExpenditureItemsForm';

export const ExpenditureItemsSidePanel: FC = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const modeData = mode?.type === 'master-management.expenditure-items' ? mode : undefined;

  const title =
    modeData?.mode === 'edit'
      ? t('master-management.expenditure-items.edit.title')
      : t('master-management.expenditure-items.create.title');

  // サイドパネル内でも会計区分データを取得（款/項の選択肢に必要、作成モード時のみ）
  const { data: accountingTypesResponse } = useListAccountingTypes(
    {
      page_size: 0,
      year: modeData ? String(modeData.fiscalYear) : undefined,
    },
    { query: { enabled: modeData?.mode === 'create' } },
  );

  const dataSource = accountingTypesResponse ?? { items: [], count: 0 };

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader
        title={title}
        onClose={() => {
          requestClose();
        }}
      />
      {modeData?.mode === 'create' && (
        <ExpenditureItemsForm mode="create" accountingTypes={dataSource} onClose={requestClose} />
      )}
      {modeData?.mode === 'edit' && (
        <ExpenditureItemsForm mode="edit" item={modeData.item} onClose={requestClose} />
      )}
      {!modeData && (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
